
class WishlistPro {
  /**
   * @param {Object} config
   * @param {string} config.baseUrl
   * @param {number} [config.shopId]
   * @param {string} [config.token]
   */
  constructor(config = {}) {
    this.baseUrl = config.baseUrl?.replace(/\/$/, "") || "";
    this.shopId = config.shopId || null;
    this.accessToken = config.token || null;

    this.drawerSelector = ".wishlist-drawer";
    this.drawerListSelector = ".wishlist-drawer .grid-lists";
    this.productPayload = {};

    this.initEvents();
  }

  async request(endpoint, method = "GET", body = null) {
    const headers = {
      "Content-Type": "application/json",
    };

    try {
      const response = await fetch(`${this.baseUrl}${endpoint}`, {
        method,
        headers,
        body: body ? JSON.stringify(body) : undefined,
      });

      const contentType = response.headers.get("content-type");
      const data =
        contentType && contentType.includes("application/json")
          ? await response.json()
          : await response.text();

      if (!response.ok) {
        console.error("❌ Wishlist API Error:", data);
        throw new Error(data?.message || `Request failed: ${response.status}`);
      }

      return data;
    } catch (error) {
      console.error("Wishlist API Exception:", error);
      throw error;
    }
  }

  async lists({ shop, customerId, page = 1, perPage = 10 }) {
    const params = new URLSearchParams({
      shop,
      id: customerId,
      page,
      per_page: perPage,
    }).toString();

    return this.request(`/lists?${params}`, "GET");
  }

  async create({ shop_id, customer_id, name }) {
    return this.request(`/lists`, "POST", { shop_id, customer_id, name });
  }

  async deleteList(id, token) {
    return this.request(`/lists/${id}`, "DELETE", { token });
  }

  async listItems({ token, shared, id }) {
    const params = new URLSearchParams({ token, shared, id }).toString();
    return this.request(`/list/items?${params}`, "GET");
  }

  async createItem(item) {
    return this.request(`/list/items`, "POST", item);
  }

  async updateItem(id, data) {
    return this.request(`/list/items/${id}`, "PUT", data);
  }

  async deleteItem(id, token) {
    return this.request(`/list/items/${id}`, "DELETE", { token });
  }

  async share(data) {
    return this.request(`/list/share`, "POST", data);
  }

  async download(data) {
    return this.request(`/generate/pdf`, "POST", data);
  }

  async downloadPDF(url) {
    window.open(url, '_blank');
  }

  async getSharedList(id, token){
    return this.request(`/list/shared`, "POST", { id, token });
  }

  // ---------------------------
  // 🔹 Event Handlers
  // ---------------------------
  initEvents() {
    document.addEventListener("click", (e) => {
      const btn = e.target.closest(".button-wishlist-drawer");
      if(e.target && e.target.getAttribute('id') == 'CartDrawer-Overlay'){
        const drawer = document.querySelector(".wishlist-drawer");
        if (drawer){
          drawer.classList.remove("active");
          document.querySelector("body").classList.remove("overflow-hidden");
        }
      }
      if (btn) {
        const drawer = document.querySelector(".wishlist-drawer");
        if (drawer){
          drawer.classList.add("active");
          document.querySelector("body").classList.add("overflow-hidden");
        }

        this.productPayload = {
          "external_id": btn.dataset.id,
          "external_type": "ProductVariant",
          "name": btn.dataset.title,
          "handle": btn.dataset.handle,
          "price": btn.dataset.price,
          "image_url": btn.dataset.image,
          "color": btn.dataset.color,
          "size": btn.dataset.size,
          "sku": btn.dataset.sku,
        };

        this.loadDrawerLists();
      }
    });

    document.addEventListener("click", (e) => {
      const closeBtn = e.target.closest(".wishlist-drawer .drawer__close");
      if (closeBtn) {
        const drawer = document.querySelector(".wishlist-drawer");
        if (drawer) drawer.classList.remove("active");

        document.querySelector("body").classList.remove("overflow-hidden");
      }
    });

    document.addEventListener("click", async (e) => {
      let card = e.target;

      if (!card.classList || !card.classList.contains('add_project')) {
        card = e.target.closest('.add_project');
      }

      if (!card) return;

      document.body.classList.add("popup-show", "overflow-hidden");
      document.querySelector(".wishlist-drawer .create_project").classList.remove("hidden");
      document.querySelector(".wishlist-drawer .add_to_project").classList.add("hidden");

      const today = new Date().toISOString().split("T")[0];
      document.querySelector(".wishlist-drawer .create_project .field__pname").value = today;
    });

    document.addEventListener("click", async (e) => {
      let button = e.target;

      if (!button.classList || !button.classList.contains("create-button")) {
        button = e.target.closest(".create-button");
      }

      if(e.target.closest(".wishlist-drawer") == null){
        button = null;
      }

      if (!button) return;

      button.disabled = true;
      button.textContent = "Creating...";

      try {
        const popup = button.closest(".create_project");  
        const nameInput = popup?.querySelector('.field__pname');
        const name = nameInput?.value?.trim();
        let customerId = document.querySelector("#customer_id").value;

        if (!name) {
          $wishlistApp.showErrorMessage("Please enter a project name.");
          button.disabled = false;
          button.textContent = "Create";
          return;
        }

        const payload = {
          shop_id: $appObj.shop,
          customer_id: customerId,
          name: name,
        };

        const response = await $wishlistApp.create(payload);

        document.body.classList.remove("popup-show", "overflow-hidden");
        popup.classList.add("hidden");

        let payloadProduct = $wishlistApp.productPayload;
        payloadProduct['token'] = response.token;
        await $wishlistApp.createItem(payloadProduct);

        const lists = await $wishlistApp.lists({
          shop: $appObj.shop,
          customerId: customerId,
          page: 1,
          perPage: 11,
        });
        this.loadDrawerLists();
        $wishlistApp.showSuccessMessage('Project "'+ name +'" successfully created!');

      } catch (error) {
        $wishlistApp.showErrorMessage("Something went wrong creating the wishlist. Try again.");
      } finally {
        button.disabled = false;
        button.textContent = "Create";
      }
    });

    document.addEventListener("click", async (e) => {
      let card = e.target;

      // if (!card.classList || !card.classList.contains('section-title')) {
      //   card = e.target.closest('.wishlist-drawer .project_added .section-title');
      // }

      if(card.classList && card.classList.contains('project_added')){
        card = e.target.querySelector('.section-title')
      }

      if (!card) return;
      
      const token = card.dataset.id;
      if (!token) return;

      let payload = this.productPayload;
      payload['token'] = token;

      await this.createItem(payload);
      await this.loadDrawerLists();

      $wishlistApp.showSuccessMessage('Item successfully added into the project!');
    });

    // document.addEventListener("click", async (e) => {
    //   let button = e.target;

    //   if (!button.classList || !button.classList.contains('button-download')) {
    //     button = e.target.closest('.button-download');
    //   }

    //   if (!button) return;
      
    //   const token = button.dataset.token;
    //   if (!token) return;

    //   let payload = {'token': token};

    //   $wishlistApp.showSuccessMessage("Please wait we are generating PDF for you!");

    //   let response = await this.download(payload);
    //   await this.downloadPDF(response.url);      
    // });

    document.addEventListener("click", async (e) => {
      let button = e.target;
      if (!button.classList || !button.classList.contains("button-download")) {
        button = e.target.closest(".button-download");
      }
      if (!button) return;

      const token = button.dataset.token;
      if (!token) return;

      const payload = { token };

      const downloadWindow = window.open("", "_blank");

      $wishlistApp.showSuccessMessage("Please wait, generating your PDF...");

      try {
        const response = await this.download(payload);
        if (response && response.url) {
          downloadWindow.location.href = response.url;
        } else {
          downloadWindow.close();
          $wishlistApp.showErrorMessage("Failed to generate the PDF link.");
        }
      } catch (err) {
        console.error("PDF download error:", err);
        downloadWindow.close();
        $wishlistApp.showErrorMessage("Error generating PDF. Please try again.");
      }
    });

  }

  renderWishLists(wishlists, container) {
    container.innerHTML = "";

    const addCard = `
      <div class="add_project">
        <button class="button button--tertiary pr_add-icon" id="addProjectBtn">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M8 4V12M12 8L4 8" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <span class="body-text">Create new project</span>   
      </div>
    `;
    container.insertAdjacentHTML("beforeend", addCard);

    // document.querySelector(".total-projects.section-title").innerHTML = "[" + wishlists.length + " lists]";

    wishlists.forEach((list) => {
      const images = (list.items || []).slice(0, 4).map(item => item.image_url).filter(Boolean);

      const gridImages = Array(4)
        .fill(null)
        .map((_, i) =>
          images[i]
            ? `<figure><img src="${images[i]}" alt="${list.name}" loading="lazy"></figure>`
            : `<figure></figure>`
        )
        .join("");

      let downloadButton = `<button class="button button--tertiary button-download" data-token="${list.token}">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
            <path d="M2 11.5V13C2 13.8284 2.67157 14.5 3.5 14.5H12.5C13.3284 14.5 14 13.8284 14 13V11.5M11 8.5L8 11.5M8 11.5L5 8.5M8 11.5V2.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          Download
        </button>`;

      if(list.items.length == 0){
        downloadButton = '';
      }

      const html = `
        <div class="project_added">
          <div class="projects_wrapper">
            <div class="images-grid">
              ${gridImages}
            </div>
            <div class="content-wrapper">
              <div class="name_date-wrap">
                <div class="date-subtitle section-subheading">
                  <div class="date">${list.created_date || this.formatDate(list.created_at)}</div>
                </div>
                <h5 class="card__title section-title h5" data-id="${list.token}">
                  <a class="unstyled-link" href="javascript:;">${this.escapeHtml(list.name)}</a>
                </h5>
              </div>
              <div class="button-wrapper hidden">
                ${downloadButton}
                <button class="button button--tertiary button-share" data-id="${list.id}" data-token="${list.token}" data-name="${list.name}" data-url="https://newprocontainers.myshopify.com/pages/wishlist?token=${list.token}">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                    <path d="M9 4.5H3.5C2.67157 4.5 2 5.17157 2 6V13C2 13.8284 2.67157 14.5 3.5 14.5H10.5C11.3284 14.5 12 13.8284 12 13V7.5M5 11.5L14 2.5M14 2.5L10.5 2.5M14 2.5V6" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  Share
                </button>
              </div>
            </div>
          </div>
          <button class="button button--primary pr_add-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M8 4V12M12 8L4 8" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
          </button>
        </div>
      `;

      container.insertAdjacentHTML("beforeend", html);
    });
  }

  formatDate(dateString) {
    if (!dateString) return "";
    const d = new Date(dateString);
    return d.toISOString().split("T")[0]; // YYYY-MM-DD
  }

  escapeHtml(text) {
    const div = document.createElement("div");
    div.textContent = text;
    return div.innerHTML;
  }

  // Fetch and render lists in the drawer
  async loadDrawerLists() {
    const drawerContainer = document.querySelector(this.drawerListSelector);
    if (!drawerContainer) return;

    let customerId = document.querySelector("#customer_id").value;
    let wishLists = await this.lists({
      shop: $appObj.shop,
      customerId: customerId,
      page: 1,
      perPage: 11,
    });

    this.renderWishLists((wishLists.data || wishLists), drawerContainer);
    document.querySelector(".wishlist-drawer .add_to_project").classList.remove("hidden");
    document.querySelector(".wishlist-drawer .create_project").classList.add("hidden");
  }

  showSuccessMessage(message){
    const toast = document.querySelector(".toast-message");
    const successMessage = toast.querySelector(".success-message");
    const popupContent = toast.querySelector(".popup-content");

    successMessage.innerHTML = message;
    popupContent.classList.remove("error");
    toast.classList.add("active");
    
    setTimeout(function() {
      toast.classList.remove("active");
    }, 2500);
  }

  showErrorMessage(message){
    const toast = document.querySelector(".toast-message");
    const errorMessage = toast.querySelector(".error-message");
    const popupContent = toast.querySelector(".popup-content");

    errorMessage.innerHTML = message;
    popupContent.classList.add("error");
    toast.classList.add("active");
    
    setTimeout(function() {
      toast.classList.remove("active");
    }, 2500);
  }

}

window.WishlistPro = WishlistPro;
